import React from "react";
import SEO from "components/seo/seo";

const calculatorUrl = "http://160.250.205.62:8085";

const NoCodeAppBudgetCalculator = () => {
  React.useEffect(() => {
    const { body, documentElement } = document;
    const previousBodyOverflow = body.style.overflow;
    const previousHtmlOverflow = documentElement.style.overflow;

    body.style.overflow = "hidden";
    documentElement.style.overflow = "hidden";

    return () => {
      body.style.overflow = previousBodyOverflow;
      documentElement.style.overflow = previousHtmlOverflow;
    };
  }, []);

  return (
    <main
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        background: "#fff",
        overflow: "hidden",
        zIndex: 9999,
      }}
    >
      <iframe
        src={calculatorUrl}
        title="No Code App Budget Calculator"
        loading="eager"
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          border: 0,
        }}
      />
    </main>
  );
};

export const Head = () => {
  const liveUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <SEO
      canonical={liveUrl}
      title="No Code App Budget Calculator | Evolvan"
      description="Estimate your no-code app budget with Evolvan's no-code app budget calculator."
    />
  );
};

export default NoCodeAppBudgetCalculator;
